import { SerializedData, Store } from 'bernie-core';
import { Logger, NOOP_LOGGER } from 'bernie-logger';
import Reaptcha from 'reaptcha';

export class CaptchaStore extends Store {
  private captchaRef: Reaptcha;
  private verified;
  private callback;
  private waitingForVerification;

  public constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
    this.captchaRef = null;
    this.verified = false;
    this.callback = null;
    this.waitingForVerification = false;
  }

  public verifyCallback = () => {
    this.verified = true;
    this.waitingForVerification = false;
    if (this.callback) {
      this.callback();
    }
    this.callback = null;
  };

  public verifyCaptcha = (callback): void => {
    if (this.verified || process.env.NODE_ENV === 'test-ci') {
      callback();
    } else if (this.waitingForVerification) {
      //todo: captcha already in use, throw error?
      return;
    }

    this.callback = callback;
    this.waitingForVerification = true;
    this.captchaRef.execute();
  };

  public expireCallback = () => {
    this.verified = false;
    this.waitingForVerification = false;
    this.callback = null;
    this.captchaRef.reset();
  };

  public setCaptchaRef = (captchaRef) => {
    // will be set when mounting and cleared when unmounting
    this.captchaRef = captchaRef;

    this.verified = false;
    this.callback = null;
    this.waitingForVerification = false;
  };

  public hydrate(data: SerializedData): void {
    //noop
  }
}
